import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

const ITEM_OPTIONS = [
  'Chip bags / snack wrappers', 'Candy bar wrappers', 'Treat toppers', 'Water bottle wraps',
  'Favor tags', 'Stickers', 'Invitations', 'Seating chart', 'Signage / posters',
  'Coloring book or activity pages', 'Party games', 'Other',
];

const STYLE_LABELS = {
  minimal: 'Minimal / Modern',
  playful: 'Fun / Playful',
  elegant: 'Elegant / Luxe',
  bold: 'Bold / Colorful',
  'not-sure': 'Not sure — I trust your vision',
};

export const ItemsSection = ({ formData, set, onItemToggle }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 3: WHAT ARE YOU LOOKING TO CREATE?</h3>

    <div>
      <Label className="text-charcoal-ink mb-3 block">What items do you need designed? *</Label>
      <div className="space-y-3">
        {ITEM_OPTIONS.map((item) => (
          <div key={item} className="flex items-center space-x-2">
            <Checkbox
              id={item}
              checked={formData.items.includes(item)}
              onCheckedChange={() => onItemToggle(item)}
            />
            <Label htmlFor={item} className="text-charcoal-ink font-normal cursor-pointer">{item}</Label>
          </div>
        ))}
      </div>
    </div>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Do you want: *</Label>
      <RadioGroup value={formData.deliveryType} onValueChange={(value) => set('deliveryType', value)}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="digital" id="digital-only" />
          <Label htmlFor="digital-only" className="text-charcoal-ink font-normal cursor-pointer">Digital files only</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="printed" id="printed" />
          <Label htmlFor="printed" className="text-charcoal-ink font-normal cursor-pointer">Printed items shipped to me</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="not-sure" id="not-sure-delivery" />
          <Label htmlFor="not-sure-delivery" className="text-charcoal-ink font-normal cursor-pointer">Not sure yet (recommendations welcome)</Label>
        </div>
      </RadioGroup>
    </div>
  </div>
);

export const DesignDirectionSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 4: DESIGN DIRECTION</h3>

    <div>
      <Label htmlFor="theme" className="text-charcoal-ink">Theme or Occasion *</Label>
      <Textarea
        id="theme"
        required
        value={formData.theme}
        onChange={(e) => set('theme', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[100px]"
        placeholder="Describe your theme or occasion in detail..."
      />
    </div>

    <div>
      <Label htmlFor="colors" className="text-charcoal-ink">Color Preferences *</Label>
      <Input
        id="colors"
        required
        value={formData.colors}
        onChange={(e) => set('colors', e.target.value)}
        className="bg-white border-stone-taupe/20"
        placeholder="e.g., Blush pink, gold, ivory"
      />
    </div>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Style Preference *</Label>
      <RadioGroup value={formData.style} onValueChange={(value) => set('style', value)}>
        {Object.entries(STYLE_LABELS).map(([value, label]) => (
          <div key={value} className="flex items-center space-x-2">
            <RadioGroupItem value={value} id={value} />
            <Label htmlFor={value} className="text-charcoal-ink font-normal cursor-pointer capitalize">{label}</Label>
          </div>
        ))}
      </RadioGroup>
    </div>

    <div>
      <Label htmlFor="specificElements" className="text-charcoal-ink">Specific characters, images, or elements to include</Label>
      <Textarea
        id="specificElements"
        value={formData.specificElements}
        onChange={(e) => set('specificElements', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[100px]"
        placeholder="List any specific elements you'd like included..."
      />
      <p className="text-xs text-stone-taupe mt-1">⚠️ Client is responsible for confirming usage rights for any copyrighted characters.</p>
    </div>
  </div>
);
